import React, { useEffect, useRef } from 'react';
import DragHandleMenu from '../../FlowchartView/TaskNode/DragHandleMenu';
import IconPicker from '../../shared/IconPicker';
import { useIconPicker } from '../../hooks/useIconPicker';

/** The card menu opened from the options button beside a mission. */
export default function BoardCardMenu({ task, flow, menuRef }) {
  const dragMenuRef = useRef(null);
  const iconPicker = useIconPicker({
    taskId: task.id,
    onIconChange: flow.onIconChange,
  });
  const menu = () => menuRef.current;

  useEffect(() => {
    const onOpen = (event) => {
      if (event.detail?.taskId !== task.id || !dragMenuRef.current) return;
      const handleRect = event.detail.handleRect;
      if (!handleRect) return;
      const menuHeight = 420;
      let top = handleRect.top;
      if (top + menuHeight > window.innerHeight) top = window.innerHeight - menuHeight - 10;
      let left = handleRect.left - 180;
      if (left < 10) left = handleRect.right + 8;
      dragMenuRef.current.openAtPosition(left, top);
    };
    window.addEventListener('openTaskDragMenu', onOpen);
    return () => window.removeEventListener('openTaskDragMenu', onOpen);
  }, [task.id]);

  return (
    <>
      <DragHandleMenu
        ref={dragMenuRef}
        task={task}
        nestedSprint={(flow.nestedSprints || []).find((sprint) => sprint.id === task.nestedSprintId) || null}
        hasNestedSprint={!!task.nestedSprintId}
        hasIcon={!!task.icon}
        onOpenDetails={() => flow.onOpenDetails?.(task.id)}
        onOpenAttachments={() => flow.onOpenAttachments?.(task.id)}
        onAddNoteOnHost={flow.onAddNoteOnHost}
        onAddMilestoneOnHost={flow.onAddMilestoneOnHost}
        onAddIcon={iconPicker.openPicker}
        onCopy={() => menu()?.copyNode?.(task.id)}
        onDuplicate={() => menu()?.duplicateNode?.(task.id)}
        onCreateParallelMission={flow.onCreateParallelMission
          ? () => flow.onCreateParallelMission(task.id)
          : null}
        onOpenNestedSprint={flow.onOpenNestedSprint
          ? () => flow.onOpenNestedSprint(task.nestedSprintId)
          : null}
        onCreateNestedSprint={flow.onCreateNestedSprint
          ? () => flow.onCreateNestedSprint(task.id)
          : null}
        onExplodeNestedCampaign={flow.onExplodeNestedCampaign}
        onArchive={flow.onArchiveTask ? () => flow.onArchiveTask(task.id) : null}
        onUnarchive={flow.onUnarchiveTask ? () => flow.onUnarchiveTask(task.id) : null}
        onDelete={() => flow.onDeleteTask?.(task.id)}
      />
      {iconPicker.showPicker && (
        <IconPicker
          currentIcon={task.icon}
          onIconChange={iconPicker.changeIcon}
          onIconDeleted={() => iconPicker.changeIcon(null)}
          onClose={iconPicker.closePicker}
          position={iconPicker.pickerPosition}
        />
      )}
    </>
  );
}
